import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2a6aac6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-camera" }
const _hoisted_2 = {
  key: 0,
  class: "content-top"
}
const _hoisted_3 = { class: "btn-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pagination-list" }
const _hoisted_6 = { class: "channel-list" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("全部通道")
const _hoisted_8 = { class: "content-camera" }
const _hoisted_9 = {
  key: 1,
  class: "content-bottom"
}
const _hoisted_10 = { class: "channel-list" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("全部通道")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_multiFrame = _resolveComponent("multiFrame")!
  const _component_ptzControl = _resolveComponent("ptzControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btnInfo, (item, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn-item", _ctx.pageSize === item.value ? 'active' : '']),
                  onClick: ($event: any) => (_ctx.changeNum(item.value)),
                  key: index
                }, _toDisplayString(item.label), 11, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Pagination, {
                simple: "",
                current: _ctx.currentPage,
                "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                "page-size": _ctx.pageSize,
                total: _ctx.videos.length,
                onChange: _ctx.onChange
              }, null, 8, ["current", "page-size", "total", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Select, {
                value: _ctx.curChannel,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.curChannel) = $event)),
                style: {"width":"120px","height":"34px"},
                onChange: _ctx.selectChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Option, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (item, key) => {
                    return (_openBlock(), _createBlock(_component_Option, {
                      key: key,
                      value: key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_multiFrame, {
          urls: _ctx.urls,
          playerNum: _ctx.pageSize
        }, null, 8, ["urls", "playerNum"])
      ]),
      (_ctx.isSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_ptzControl, {
              class: "bottom-left",
              info: _ctx.showVideos[0]
            }, null, 8, ["info"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Select, {
                value: _ctx.curChannel,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.curChannel) = $event)),
                style: {"width":"120px","height":"34px"},
                onChange: _ctx.selectChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Option, { value: "all" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (item, key) => {
                    return (_openBlock(), _createBlock(_component_Option, {
                      key: key,
                      value: key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}